const NAME = "LOGIN_PAGE";

export default NAME;
